import './dashboard.css';

const Dashboard = () => {
  return (
    <div id="dashboard">
      <div className="head">
        <h1>Dashboard</h1>
      </div>
      <div className="body">
        
      </div>
      <div className="foot">
        
      </div>
    </div>
  );
};

export default Dashboard;
